/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrainingMaterialsRoutingModule} from './training-materials-routing.module';
import {TrainingMaterialsMainPageModule} from './training-materials-main-page/training-materials-main-page.module';

@NgModule({
    imports: [
        CommonModule,
        TrainingMaterialsRoutingModule,
        TrainingMaterialsMainPageModule
    ]
})
export class TrainingMaterialsModule {
}

